
import _ from 'lodash';
import kv from 'knockout.validation';

import vb from './definition';


import {
	findInvalid,
	findValid,
} from './util';


vb.cond = (clauses) => {
	clauses = _.map(clauses, (([predicate, result]) => [predicate, _.constant(result)]));
	const choose = _.cond(clauses);
	return {
		validator: (...args) => choose().validator(...args),
		message: (...args) => choose().message(...args),
	};
};

vb.ternary = (condition, then, otherwise) => {
	const choose = () => condition() ? then : otherwise;
	return {
		validator: (...args) => choose().validator(...args),
		message: (...args) => kv.formatMessage(choose().message, ...args),
	};
};

vb.if = (condition, then, velse) => {
	return vb.ternary(condition, then, velse || vb.valid());
};

vb.all = (validators) => {
	return {
		validator: (...args) => !findInvalid(validators, ...args),
		message: (params, observable) => {
			params = params === undefined ? true : params;
			const firstInvalid = findInvalid(validators, observable(), params);
			const message = firstInvalid
				&& kv.formatMessage(firstInvalid.message, params, observable);
			return message;
		},
	};
};

vb.any = (validators) => {
	return {
		validator: (...args) => Boolean(findValid(validators, ...args)),
		message: (params, observable) => {
			params = params === undefined ? true : params;

			const firstValid = findValid(validators, observable(), params);
			if (firstValid) {
				return null;
			}

			const firstInvalid = findInvalid(validators, observable(), params);
			const message = firstInvalid
				&& kv.formatMessage(firstInvalid.message, params, observable);
			return message;
		},
	};
};

vb.map = (map, validator) => {
	return {
		validator: (v, ...rest) => validator.validator(map(v), ...rest),
		message: validator.message,
	};
};

vb.proxy = (validationAccessor) => {
	return {
		validator: (...args) => validationAccessor().validator(...args),
		message: (...args) => kv.formatMessage(validationAccessor().message, ...args),
	};
};
